<div id="toggler" class="row py-2 align-items-center" (click)="isCollapsed = !isCollapsed">
    <div class="col-1">
        <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
    </div>
    <div data-material="material-number" [ngClass]="showBootstockActionColumn() ? 'col-2' : 'col-4'">
        {{ material().materialIdentifier.materialNumber.value }}
    </div>
    <div class="form-control-static" [ngClass]="showBootstockActionColumn() ? 'col-5 text-center' : 'col-3'">
        {{ material().description.value }}
    </div>
    <div
        class="d-flex align-items-center"
        [ngClass]="showBootstockActionColumn() ? 'col-2' : 'col-4 justify-content-center'"
    >
        <span class="pe-2" data-material="delivered-quantity">{{ material().deliveredQuantity }}</span>
    </div>
    @if (showBootstockActionColumn() && isLoadingBootStockActions()) {
        <div
            class="col-2 pe-0 pe-md-2 d-flex flex-wrap justify-content-end gap-1"
            data-material="bootstock-actions-loading"
        >
            <button type="button" class="btn btn-primary" disabled>
                <fa-icon [icon]="faLoading" animation="spin" aria-hidden="true"></fa-icon>
                {{ BOOTSTOCK_RETURN_ACTION.RETURN }}
            </button>
            <button type="button" class="btn btn-secondary" disabled>
                <fa-icon [icon]="faLoading" animation="spin" aria-hidden="true"></fa-icon>
                {{ BOOTSTOCK_RETURN_ACTION.SCRAP }}
            </button>
        </div>
    } @else if (showBootstockActionColumn() && bootstockReturnAction() !== BOOTSTOCK_RETURN_ACTION.NONE) {
        <div class="col-2 pe-0 pe-md-2 d-flex justify-content-end">
            <button
                type="button"
                class="btn"
                [ngClass]="bootstockReturnAction() === BOOTSTOCK_RETURN_ACTION.RETURN ? 'btn-primary' : 'btn-secondary'"
                (click)="$event.stopPropagation(); openBootstockReturnDialog(material(), bootstockReturnAction())"
            >
                {{ bootstockReturnAction() }}
            </button>
        </div>
    }
</div>
@if (!isCollapsed) {
    <div class="material-expanded-content py-3" [ngClass]="{ collapsed: isCollapsed, expanded: !isCollapsed }">
        @if (isModelNotification()) {
            <div class="row align-items-center">
                <div class="col d-flex justify-content-center my-2">
                    @if (!smartlockerData()) {
                        <pace-core-number-stepper
                            (click)="$event.stopPropagation()"
                            [(model)]="material().quantity"
                            name="quantity"
                            [ariaLabel]="'CONFIRMATION_MATERIAL_STOCK_QUANTITY_ARIA_LABEL' | translate"
                        ></pace-core-number-stepper>
                    } @else {
                        <span class="fw-bold col-7 col-sm-4 offset-1">Picked up quantity:</span>
                        <span data-material="batch-number-legacy" class="col-4 form-control-static">
                            {{ material().quantity.value }}
                        </span>
                    }
                </div>
            </div>
        }
        <div class="row align-items-center my-2">
            <span
                class="fw-bold col-7 col-sm-4 offset-1"
                translate="CONFIRMATION_MATERIAL_CSE_STOCK_LABEL_BATCHID"
            ></span>
            <span data-material="batch-number-legacy" class="col-4 form-control-static">
                {{ material().batchNumberLegacy ? material().batchNumberLegacy : material().batchNumber.value }}<br />
            </span>
        </div>
        <div class="row align-items-center">
            <span
                class="fw-bold col-7 col-sm-4 offset-1"
                translate="CONFIRMATION_MATERIAL_CSE_STOCK_LABEL_STORAGE_LOCATION"
            ></span>
            <span data-material="storage-location" class="col-4 form-control-static">
                {{ material().storageLocation.value }}<br />
            </span>
        </div>
        <div class="row align-items-center my-2">
            <span
                class="fw-bold col-7 col-sm-4 offset-1"
                translate="CONFIRMATION_MATERIAL_CSE_STOCK_LABEL_STORAGE_DESC"
            ></span>
            <span data-material="storage-location-desc" class="col-3 pe-0 form-control-static">
                {{ material().storageLocationDesc.value }}<br />
            </span>
        </div>
        <div class="row align-items-center my-2">
            <span class="fw-bold col-7 col-sm-4 offset-1" translate="CONFIRMATION_MATERIAL_CSE_STOCK_LABEL_UCR"></span>
            <span data-material="ucr" class="col-4 form-control-static"> {{ material().ucrNumber }}<br /> </span>
        </div>
        @if (smartlockerData()) {
            <div class="row align-items-center my-2">
                <div
                    class="fw-bold col-11 offset-1 mt-2"
                    [translate]="'CONFIRMATION_MATERIAL_CSE_STOCK_SMARTLOCKER_DETAILS_LABEL'"
                ></div>
                <div class="col-6 offset-1">
                    <span>{{ smartlockerData().Street }}, {{ smartlockerData().City }}</span>
                </div>
                <button
                    type="button"
                    class="btn btn-primary col-4"
                    (click)="openSmartlockerPickupModal()"
                    [attr.disabled]="(material()?.quantity?.value ?? 0) > 0 ? '' : null"
                    [translate]="'CONFIRMATION_MATERIAL_CSE_STOCK_SMARTLOCKER_PICKUP_PROCESS'"
                ></button>
            </div>
        }
    </div>
}
